<script>
export default {
  name: 'TableContent',
  props: {
    noSpacing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        '-noSpacing': this.noSpacing,
      };
    },
  },
};
</script>

<template>
  <div
    :class="classes"
    class="cxm-TableContent"
  >
    <header
      v-if="$scopedSlots.header || $scopedSlots.filters || $scopedSlots.tools"
      class="cxm-TableContent-Header"
    >
      <slot name="header">
        <div
          v-if="$scopedSlots.filters"
          class="cxm-TableContent-Filters"
        >
          <slot name="filters" />
        </div>

        <div
          v-if="$scopedSlots.tools"
          class="cxm-TableContent-Tools"
        >
          <slot name="tools" />
        </div>
      </slot>
    </header>

    <div
      v-if="$scopedSlots.info"
      class="cxm-TableContent-Info"
    >
      <slot name="info" />
    </div>

    <div class="cxm-TableContent-Table js-InteractionTable-HandleScroll">
      <slot />
    </div>

    <div
      v-if="$scopedSlots.empty"
      class="cxm-TableContent-Empty"
    >
      <slot name="empty" />
    </div>

    <div
      v-if="$scopedSlots.pagination"
      class="cxm-TableContent-Pagination"
    >
      <slot name="pagination" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cxm-TableContent {
  align-items: stretch;
  background-color: var(--track-color-white);
  border-radius: var(--track-border-radius-sm);
  display: flex;
  flex-direction: column;
  max-height: calc(97vh - var(--track-spacing-bg) - var(--track-spacing-bg) - 60px); // NOTE: 60px é a altura do header
  padding: var(--track-spacing-bg);

  &.-noSpacing {
    padding: 0;
  }
}

.cxm-TableContent-Header,
.cxm-TableContent-Filters,
.cxm-TableContent-Tools {
  align-items: center;
  display: flex;
}

.cxm-TableContent-Header {
  justify-content: space-between;
  margin-bottom: var(--track-spacing-md);
}

.cxm-TableContent-Filters {
  justify-content: flex-start;
}

.cxm-TableContent-Tools {
  justify-content: flex-end;
}

.cxm-TableContent-Info {
  display: flex;
  align-items: center;
  color: var(--track-color-bluegray-80);
  gap: var(--track-spacing-xs);
  margin-bottom: var(--track-spacing-md);
}

.cxm-TableContent-Table {
  background-color: var(--track-color-bluegray-10);
  border: solid var(--track-color-bluegray-20);
  border-width: 0 var(--track-border-sm);
  border-top-left-radius: var(--track-border-radius-sm);
  border-top-right-radius: var(--track-border-radius-sm);
  overflow-x: auto;
  flex: 1;
}

.cxm-TableContent-Empty {
  align-items: center;
  border: var(--track-border-sm) solid var(--track-color-bluegray-20);
  border-top-width: 0;
  border-bottom-left-radius: var(--track-border-radius-sm);
  border-bottom-right-radius: var(--track-border-radius-sm);
  display: flex;
  justify-content: center;
  min-height: 60vh;
}

.cxm-TableContent-Pagination {
  border: var(--track-border-sm) solid var(--track-color-bluegray-20);
  border-bottom-left-radius: var(--track-border-radius-sm);
  border-bottom-right-radius: var(--track-border-radius-sm);
  padding: var(--track-spacing-sm);
  width: 100%;

  .cxm-TableContent-Empty + & {
    display: none;
  }
}
</style>
